import React, { useEffect, useState } from "react";

interface PanelProps {
  title: string;
  tailwindBorderStyles: string;
  open: boolean;
  children: React.ReactNode;
  multiPanel?: boolean;
  secondTitle?: string;
  secondPanelChildren?: React.ReactNode;
  isFirstPanelOpen?: boolean;
  setIsFirstPanelOpen?: (isFirstPanelOpen: boolean) => void;
}

const Panel = (props: PanelProps) => {
  const [secondPanelOpen, setSecondPanelOpen] = useState(false);

  const handleTabClick = (tab: string) => {
    if (tab === "first") {
      setSecondPanelOpen(false);

      if (props.setIsFirstPanelOpen) {
        props.setIsFirstPanelOpen(true);
      }
    } else {
      if (props.setIsFirstPanelOpen) {
        props.setIsFirstPanelOpen(false);
      }
      setSecondPanelOpen(true);
    }
  };

  useEffect(() => {
    if (props.multiPanel) {
      if (props.isFirstPanelOpen) {
        setSecondPanelOpen(false);
      } else {
        setSecondPanelOpen(true);
      }
    }
  }, [props.isFirstPanelOpen, props.multiPanel]);

  return (
    <div className={`flex flex-shrink-0 flex-[0.4] bg-white flex-col overflow-y-scroll ${props.tailwindBorderStyles} ${props.open ? "flex" : "hidden"}`}>
      {props.multiPanel ? (
        <>
          <div className="flex flex-row font-medium border-2 border-gray-200">
            <button
              className={`p-3 flex-1 ${props.isFirstPanelOpen ? "bg-gray-200 text-black font-semibold" : ""}`}
              onClick={() => handleTabClick("first")}
            >
              {props.title}
            </button>

            <button
              className={`p-3 flex-1 ${secondPanelOpen ? "bg-gray-200 text-black font-semibold" : ""}`}
              onClick={() => handleTabClick("second")}
            >
              {props.secondTitle}
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="py-3 px-4 font-bold text-base text-black border-y-2">{props.title}</div>
        </>
      )}

      {props.multiPanel ? (
        <>
          {props.isFirstPanelOpen && <div className="p-4">{props.children}</div>}

          {secondPanelOpen && <div className="p-4">{props.secondPanelChildren}</div>}
        </>
      ) : (
        <div className="p-4">{props.children}</div>
      )}
    </div>
  );
};

export default Panel;
